import { render } from "./TrainingSectionGridBlockItem.vue?vue&type=template&id=ee8d9b7a&scoped=true"
import script from "./TrainingSectionGridBlockItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionGridBlockItem.vue?vue&type=script&lang=js"

import "./TrainingSectionGridBlockItem.vue?vue&type=style&index=0&id=ee8d9b7a&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8d9b7a"]])

export default __exports__